import { UcoastEl } from '@/scripts/core/UcoastEl'
import EmblaCarousel, {
	type EmblaCarouselType,
	type EmblaOptionsType,
} from 'embla-carousel'
import { qsRequired } from '@/scripts/core/global'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import ClassNames from 'embla-carousel-class-names'
import AutoHeight from 'embla-carousel-auto-height'
const OPTIONS: EmblaOptionsType = {

}
const OPTIONS_THUMBS: EmblaOptionsType = {
	inViewThreshold: 1,
	containScroll: 'keepSnaps',
	dragFree: true,
}

const addThumbBtnsClickHandlers = (
	emblaApiMain: EmblaCarouselType,
	emblaApiThumb: EmblaCarouselType
): (() => void) => {
	const slidesThumbs = emblaApiThumb.slideNodes()

	const scrollToIndex = slidesThumbs.map(
		(_, index) => (): void => emblaApiMain.scrollTo(index, true)
	)

	slidesThumbs.forEach((slideNode, index) => {
		slideNode.addEventListener('click', scrollToIndex[index], false)
	})

	return (): void => {
		slidesThumbs.forEach((slideNode, index) => {
			slideNode.removeEventListener('click', scrollToIndex[index], false)
		})
	}
}

const addToggleThumbBtnsActive = (
	emblaApiMain: EmblaCarouselType,
	emblaApiThumb: EmblaCarouselType
): (() => void) => {
	const slidesThumbs = emblaApiThumb.slideNodes()

	const toggleThumbBtnsState = (): void => {
		emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap())
		const previous = emblaApiMain.previousScrollSnap()
		const selected = emblaApiMain.selectedScrollSnap()
		slidesThumbs[previous].classList.remove('embla-thumbs__slide--selected')
		slidesThumbs[selected].classList.add('embla-thumbs__slide--selected')
	}

	emblaApiMain.on('select', toggleThumbBtnsState)
	emblaApiThumb.on('init', toggleThumbBtnsState)

	return (): void => {
		const selected = emblaApiMain.selectedScrollSnap()
		slidesThumbs[selected].classList.remove('embla-thumbs__slide--selected')
	}
}

export class IngredientsSlider extends UcoastEl {
	static htmlSelector = 'ingredients-slider'
	allSlidesLoaded = false
	constructor() {
		super()
		const viewportNodeMainCarousel = qsRequired('.embla__viewport', this)
		const viewportNodeThumbCarousel = qsRequired(
			'.embla-thumbs__viewport',
			this
		)
		const emblaApiMain = EmblaCarousel(viewportNodeMainCarousel, OPTIONS, [
			ClassNames(),
			WheelGesturesPlugin(),
			AutoHeight(),
		])

		const emblaApiThumb = EmblaCarousel(
			viewportNodeThumbCarousel,
			OPTIONS_THUMBS,
			[WheelGesturesPlugin()]
		)
		emblaApiThumb.on('select', () => {
			if (this.allSlidesLoaded) return
			void window.Ucoast.mediaManager.loadAllInContainer(this)
			this.allSlidesLoaded = true
		})
		emblaApiMain.on('select', () => {
			if (this.allSlidesLoaded) return
			void window.Ucoast.mediaManager.loadAllInContainer(this)
			this.allSlidesLoaded = true
		})
		emblaApiMain.on('scroll', (_) => {
			void window.Ucoast.mediaManager.loadAllInContainer(this)
		})
		emblaApiThumb.on('scroll', (_) => {
			void window.Ucoast.mediaManager.loadAllInContainer(this)
		})
		//defaultEmblaListeners(emblaApiMain)

		const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(
			emblaApiMain,
			emblaApiThumb
		)
		const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(
			emblaApiMain,
			emblaApiThumb
		)

		emblaApiMain
			.on('destroy', removeThumbBtnsClickHandlers)
			.on('destroy', removeToggleThumbBtnsActive)

		emblaApiThumb
			.on('destroy', removeThumbBtnsClickHandlers)
			.on('destroy', removeToggleThumbBtnsActive)
	}

	override connectedCallback() {
		super.connectedCallback()
	}
}
